<script lang="ts">
  import { onMount } from 'svelte'
  import { share, withLatestFrom } from 'rxjs/operators'
  import { fromEvent } from 'rxjs'
  import { fromPairs } from 'lodash'
  import { set_state } from '../State'
  import { card_count } from '../../Cards/observables'
  import { authed_user } from '../../Users/observables'
  import { sendEventToFirebase } from '../../logging/events'
  import CtaButton from '../../Generic/CtaButton.svelte'
  let startButton: HTMLButtonElement
  onMount(() => {
    const sub = fromEvent(startButton, 'click')
      .pipe(withLatestFrom(card_count, set_state, authed_user), share())
      .subscribe(([_clicked, card_count, set_state, authed_user]) => {
        console.log(`Starting retro with ${card_count} cards`)
        void sendEventToFirebase({
          key: 'StartRetro',
          organization: authed_user.organization,
        })
        void set_state({
          phase: 'vote',
          current_card: 1,
          shuffle: fromPairs(
            Array.from({ length: card_count })
              .map((_, i) => i)
              .sort(() => Math.random() - 0.5)
              .map((v, i) => [i, v]),
          ),
          show: false,
        })
      })
    return () => sub.unsubscribe()
  })
</script>

<CtaButton bind:inner={startButton}>Start</CtaButton>
